import { render, staticRenderFns } from "./DiseaseTrendChart.vue?vue&type=template&id=40212235&scoped=true"
import script from "./DiseaseTrendChart.vue?vue&type=script&lang=js"
export * from "./DiseaseTrendChart.vue?vue&type=script&lang=js"
import style0 from "./DiseaseTrendChart.vue?vue&type=style&index=0&id=40212235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40212235",
  null
  
)

export default component.exports